var m = Object.freeze, v = Object.defineProperty;
var l = (i, e) => m(v(i, "raw", { value: m(e || i.slice()) }));
import { L as w } from "./lds-element-BuoW29Nx.js";
import { i as C, x as I } from "./lit-element-CwWchyls.js";
import { n as p } from "./property-EvzlnPW3.js";
import { r as $ } from "./state-D88UmDIj.js";
import { i as x, o as f, c as y } from "./config-CYJMII9C.js";
var u;
const A = C(u || (u = l(["\n    :host {\n        display: inline-flex;\n        flex-shrink: 0;\n        width: 1em;\n        height: 1em;\n    }\n\n    svg {\n        height: 100%;\n        width: 100%;\n        overflow: visible;\n        fill: currentColor;\n    }\n"])));
var E = Object.defineProperty, h = (i, e, s, n) => {
  for (var o = void 0, a = i.length - 1, d; a >= 0; a--)
    (d = i[a]) && (o = d(e, s, o) || o);
  return o && E(e, s, o), o;
}, t, b;
const r = (t = class extends w {
  constructor() {
    super(...arguments), this.label = "", this.iconContent = "";
  }
  willUpdate(e) {
    e.has("name") && this.loadIcon(), e.has("label") && (typeof this.label == "string" && this.label.length > 0 ? (this.setAttribute("role", "img"), this.setAttribute("aria-label", this.label || ""), this.removeAttribute("aria-hidden")) : (this.removeAttribute("role"), this.removeAttribute("aria-label"), this.setAttribute("aria-hidden", "true")));
  }
  firstUpdated() {
    this.setAttribute("aria-hidden", "true");
  }
  render() {
    return I(b || (b = l(["", ""])), this.iconContent);
  }
  loadIcon() {
    if (this.name) {
      if (x.indexOf(this.name) === -1) {
        console.warn('lds-icon\nIcon "'.concat(this.name, '" not found.'));
        return;
      }
      if (t.iconCache.has(this.name)) {
        const e = t.iconCache.get(this.name);
        e == null || e.then((s) => {
          this.iconContent = f(s);
        });
      } else {
        const e = fetch("".concat(y.cdnUrl, "/core/v0.22.2/icons/").concat(this.name, ".svg?raw"));
        t.iconCache.set(
          this.name,
          new Promise((s) => {
            e.then((n) => n.text()).then((n) => {
              n.includes("<svg") ? (this.iconContent = f(n), s(n)) : console.warn('lds-icon\nIcon "'.concat(this.name, '" could not be loaded.'));
            }).catch(() => console.warn('lds-icon\nIcon "'.concat(this.name, '" could not be loaded.')));
          })
        );
      }
    }
  }
}, t.styles = A, t.iconCache = /* @__PURE__ */ new Map(), t);
h([
  p()
], r.prototype, "name");
h([
  p()
], r.prototype, "label");
h([
  $()
], r.prototype, "iconContent");
let c = r;
const g = new URL(import.meta.url), L = g.searchParams.has("debug");
if (!g.searchParams.has("no-define")) {
  const i = customElements.get("lds-icon");
  i ? i.VERSION !== c.VERSION && L && console.log("%clds-icon tried loading in version ".concat(c.VERSION, ", but lds-icon is already defined as ").concat(i.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-icon", c);
}
export {
  c as LdsIcon
};
